"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyValue = exports.Currency = void 0;
var Currency;
(function (Currency) {
    Currency["EUR"] = "EUR";
    Currency["USD"] = "USD";
    Currency["RUB"] = "RUB";
    Currency["AUD"] = "AUD";
    Currency["CAD"] = "CAD";
    Currency["GBP"] = "GBP";
    Currency["JPY"] = "JPY";
    Currency["HKD"] = "HKD";
    Currency["CNY"] = "CNY";
    Currency["CHF"] = "CHF";
    Currency["SEK"] = "SEK";
    Currency["DKK"] = "DKK";
    Currency["PLN"] = "PLN";
    Currency["BRL"] = "BRL";
    Currency["RON"] = "RON";
    Currency["HUF"] = "HUF";
    Currency["THB"] = "THB";
    Currency["TWD"] = "TWD";
    Currency["IDR"] = "IDR";
    Currency["MYR"] = "MYR";
    Currency["INR"] = "INR";
    Currency["KRW"] = "KRW";
    Currency["AED"] = "AED";
    Currency["NZD"] = "NZD";
    Currency["SGD"] = "SGD";
    Currency["CZK"] = "CZK";
    Currency["PHP"] = "PHP";
})(Currency = exports.Currency || (exports.Currency = {}));
var CurrencyValue;
(function (CurrencyValue) {
    CurrencyValue["EUR"] = "\u20AC";
    CurrencyValue["USD"] = "$";
    CurrencyValue["RUB"] = "\u0440\u0443\u0431";
    CurrencyValue["AUD"] = "$";
    CurrencyValue["CAD"] = "$";
    CurrencyValue["GBP"] = "\u00A3";
    CurrencyValue["JPY"] = "\u00A5";
    CurrencyValue["HKD"] = "HK$";
    CurrencyValue["CNY"] = "\u00A5";
    CurrencyValue["CHF"] = "Fr.";
    CurrencyValue["SEK"] = "kr";
    CurrencyValue["DKK"] = "kr";
    CurrencyValue["PLN"] = "zl";
    CurrencyValue["BRL"] = "R$";
    CurrencyValue["RON"] = "lei";
    CurrencyValue["HUF"] = "Ft";
    CurrencyValue["THB"] = "\u0E3F";
    CurrencyValue["TWD"] = "NT$";
    CurrencyValue["IDR"] = "Rp";
    CurrencyValue["MYR"] = "RM";
    CurrencyValue["INR"] = "\u20B9";
    CurrencyValue["KRW"] = "\u20A9";
    CurrencyValue["AED"] = "\u062F.\u0625";
    CurrencyValue["NZD"] = "$";
    CurrencyValue["SGD"] = "S$";
    CurrencyValue["CZK"] = "K\u010D";
    CurrencyValue["PHP"] = "\u20B1";
})(CurrencyValue = exports.CurrencyValue || (exports.CurrencyValue = {}));
//# sourceMappingURL=types.js.map